import { GENERAL_INFORMATION_FORMTYPE } from '../../../App/AppSettings';
import { CorporateGI, IndividualGI } from '../GeneralInformation';

export const GeneralInformationComponent = {
    [GENERAL_INFORMATION_FORMTYPE.INDIVIDUAL]: IndividualGI,
    [GENERAL_INFORMATION_FORMTYPE.CORPORATE]: CorporateGI
}

